"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselKeyboardInstructions = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardBadge = require("../PropertyCardBadge/PropertyCardBadge");
var StyledPhotoCarouselKeyboardInstructions = /*#__PURE__*/(0, _styledComponents.default)(_PropertyCardBadge.PropertyCardBadge).withConfig({
  displayName: "StyledPhotoCarouselKeyboardInstructions",
  componentId: "c11n-8-107-0__sc-hcuerh-0"
})([""]);
exports.StyledPhotoCarouselKeyboardInstructions = StyledPhotoCarouselKeyboardInstructions;